import { ISliderIndents } from '../../types';
interface IScrollToItemParams {
  slideNode: HTMLElement;
  containerNode: HTMLElement;
  enableAnimation: boolean;
  indents: ISliderIndents;
}

/**
 *
 * @description Прокручивает слайдер к заданому слайду.
 */
export function scrollToSlide(params: IScrollToItemParams) {
  const { slideNode, containerNode, enableAnimation } = params;

  // Вычисляем свдиг слева с учетом отступов
  const slideLeftOffset = slideNode.offsetLeft - containerNode.offsetLeft - (params.indents.left || 0);

  const options = {
    left: slideLeftOffset,
    behavior: enableAnimation ? 'smooth' : 'auto',
  } as const;

  containerNode.scroll?.(options);
}
